import React from 'react';
import ReactDOM from 'react-dom/client';
import './reset.css';
import './index.css';
import App from './App';
import { initContract } from "./utils";
import { Buffer } from 'buffer';

window.Buffer = Buffer;

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const root = ReactDOM.createRoot(document.getElementById('root'));

initContract()
    .then(data => {
        root.render(
            <React.StrictMode>
                <App
                    accountId={data.accountId}
                    claimableTokens={data.claimableTokens}
                    contract={data.contract}
                    nearConfig={data.nearConfig}
                    walletConnection={data.walletConnection}
                />
            </React.StrictMode>
        );
    })
    .catch(console.error);
